import React, { useState } from "react";
import * as Progress from "react-native-progress";
import Colors from "@microdoing/shared/constants/Colors";
import theme from "app/Theme/Theme";
import { Box, MainText } from "app/components/common";

const getColor = progress => {
  if (progress < 0.45) {
    return Colors.red;
  } else if (progress >= 1) {
    return Colors.green;
  }
  return Colors.yellow;
};

const displayPercentage = progress => {
  const result = progress * 100;
  if (isFinite(result)) {
    return `${result.toFixed(0)}%`;
  }
  return "";
};

interface IProps {
  categoryTitle: string;
  progress: number;
  totalDone: number;
}

const CategoryRowWithStep = ({
  categoryTitle,
  progress,
  totalDone,
}: IProps) => {
  const [width, setWidth] = useState(300);

  const findDimensions = ({ height, width }) => {
    setWidth(width - 60);
  };

  const handleOnLayout = event => {
    findDimensions(event.nativeEvent.layout);
  };

  return (
    <Box
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      marginBottom="xm"
      paddingLeft="xxs"
      width="100%"
      onLayout={handleOnLayout}
    >
      <Box
        alignItems="center"
        justifyContent="space-between"
        marginBottom="sm"
        flexDirection="row"
      >
        <MainText variant="l3-medium" marginRight="xxs">
          {categoryTitle} (
          <MainText variant="l3-semibold">{totalDone}</MainText>)
        </MainText>
        <MainText variant="l3-regular" color="neutral.400">
          {displayPercentage(progress)}
        </MainText>
      </Box>
      <Box flexDirection="row" alignItems="center" justifyContent="center">
        <Progress.Bar
          progress={progress}
          width={width}
          height={5}
          borderRadius={8}
          useNativeDriver
          borderWidth={0}
          color={getColor(progress)}
          unfilledColor={theme.colors["neutral.100"]}
        ></Progress.Bar>
      </Box>
    </Box>
  );
};

CategoryRowWithStep.defaultProps = {
  colors: ["#45A3EB", "#747BF2"],
  level: 1,
  hasInfoCircle: true,
};

export default CategoryRowWithStep;
